// extracted by mini-css-extract-plugin
module.exports =  {"calendar":"calendar-cH2jw","content":"content-wBwrQ","main":"main-vWt7d"};